import { type CostType } from "types/enum";

import { APIHandler } from "utilities/apiHandler";

import {
    CostCodeConflictForm,
    CostCodeDeleteResponse,
    CostCodeEntity,
    CostCodeUpdateResponse,
    type ICostCodeDeleteRequest,
    type ICostCodeDetailsFormValues,
} from "./CostCode.api.types";

export interface ICostCodeDetailsHandler {
    get(
        costType: CostType,
        costCodeId: number,
        laborCodesOnly: boolean,
        categoryId?: number,
    ): Promise<CostCodeEntity>;
    update(
        formData: ICostCodeDetailsFormValues,
        costCodeId: number,
        categoryId?: number,
    ): Promise<CostCodeUpdateResponse>;
    delete(request: ICostCodeDeleteRequest): Promise<CostCodeDeleteResponse>;
    create(formData: ICostCodeDetailsFormValues): Promise<CostCodeUpdateResponse>;
    conflict(costCodeId: number): Promise<CostCodeConflictForm>;
}

export class CostCodeDetailsHandler implements ICostCodeDetailsHandler {
    async get(
        costType: CostType,
        costCodeId: number,
        laborCodesOnly: boolean,
        categoryId?: number,
    ): Promise<CostCodeEntity> {
        return await APIHandler("/api/CostCodes", {
            method: "GET",
            data: {
                costCodeId: costCodeId,
                currentType: costType,
                isLabor: laborCodesOnly,
                categoryId: categoryId,
            },
            responseType: CostCodeEntity,
        });
    }

    async update(
        formData: ICostCodeDetailsFormValues,
        costCodeId: number,
    ): Promise<CostCodeUpdateResponse> {
        return await APIHandler("/api/CostCodes", {
            method: "PUT",
            data: {
                ...formData,
                costCodeId: costCodeId,
            },
            responseType: CostCodeUpdateResponse,
        });
    }

    async delete(request: ICostCodeDeleteRequest): Promise<CostCodeDeleteResponse> {
        // Endpoint requires query params but API Handler does not support sending those not in the body, thus we template the query params manually
        return await APIHandler(
            `/api/CostCodes/DefaultAction?request.costCodeId=${request.costCodeId}&request.currentType=${request.currentType}`,
            {
                method: "DELETE",
                responseType: CostCodeDeleteResponse,
            },
        );
    }

    async create(formData: ICostCodeDetailsFormValues): Promise<CostCodeUpdateResponse> {
        return await APIHandler("/api/CostCodes", {
            method: "POST",
            data: formData,
            responseType: CostCodeUpdateResponse,
        });
    }

    async conflict(costCodeId: number): Promise<CostCodeConflictForm> {
        return await APIHandler(`/api/CostCodes/CostCodeConflict`, {
            method: "GET",
            data: {
                costCodeId: costCodeId,
            },
            responseType: CostCodeConflictForm,
        });
    }
}
